/**
 * Read a value from a nested object using dot-separated field names (e.g. "party.email").
 * Returns undefined if any segment of the path is missing on the object.
 */
export function getValueByFieldName(values, fieldName) {
  if (values == null || fieldName == null || fieldName === '') return undefined;
  const parts = String(fieldName).split('.');
  let cur = values;
  for (let i = 0; i < parts.length; i++) {
    const p = parts[i];
    if (cur == null || typeof cur !== 'object' || !Object.prototype.hasOwnProperty.call(cur, p)) {
      return undefined;
    }
    cur = cur[p];
  }
  return cur;
}

/**
 * Write a value at a dot-separated path, creating plain object segments as needed.
 */
export function setValueByFieldName(obj, fieldName, value) {
  if (obj == null || fieldName == null || fieldName === '') return;
  const parts = String(fieldName).split('.');
  let cur = obj;
  for (let i = 0; i < parts.length - 1; i++) {
    const p = parts[i];
    if (cur[p] == null || typeof cur[p] !== 'object' || Array.isArray(cur[p])) {
      cur[p] = {};
    }
    cur = cur[p];
  }
  cur[parts[parts.length - 1]] = value;
}

/**
 * Remove a value at a dot-separated path without affecting sibling branches.
 */
export function deleteValueByFieldName(obj, fieldName) {
  if (obj == null || fieldName == null || fieldName === '') return;
  const parts = String(fieldName).split('.');
  if (parts.length === 1) {
    delete obj[parts[0]];
    return;
  }
  let cur = obj;
  for (let i = 0; i < parts.length - 1; i++) {
    const p = parts[i];
    if (cur[p] == null || typeof cur[p] !== 'object') {
      return;
    }
    cur = cur[p];
  }
  delete cur[parts[parts.length - 1]];
}
